<template>
  <div class="home">
    <img alt="home" src="../assets/home.png">
    <!-- <HelloWorld msg="Welcome to Your Vue.js App"/> -->
    <div class="btnBox1">
      <!-- <a class="btn-move" href="javascript:;">
        <img alt="btnMeet" src="../assets/btn-meet-close.png">
      </a> -->
      <a class="btn-move" href="https://bit.ly/2022091718-Log-in" target="_blank">
        <img alt="btnMeet" src="../assets/btn-meet.png">
      </a>
    </div>
    <div class="btnBox2">
      <a class="btn-move move-delay" href="https://evt.to/auuaaaahw?openExternalBrowser=1" target="_blank">
        <img src="../assets/btnCalendar.png" alt="btnCalendar">
      </a>
      <a href="https://app.micepad.co/pages/#/register/2022091718-ois-amgen" target="_blank">
        <img src="../assets/btn-register.png" alt="btnRegister">
      </a>
      <!-- <a href="https://bit.ly/2022091718-Log-in">
        <img src="../assets/btnEnterMeet.png" alt="btnEnterMeet">
      </a> -->
      <router-link to="/intro">
        <img src="../assets/btnIntroduction.png" alt="btnIntroduction">
      </router-link>
      <!-- <a href="javascript:;">
        <img src="../assets/btnLecturer.png" alt="btnLecturer">
      </a> -->
      <router-link to="/cv">
        <img src="../assets/btnCv.png" alt="btnCv">
      </router-link>
      <!-- <a href="javascript:;">
        <img src="../assets/btnReview.png" alt="btnReview">
      </a> -->
      <router-link to="/video">
        <img src="../assets/btnEnterReview.png" alt="btnEnterReview">
      </router-link>
    </div>
    <div class="logoBox">
      <img class="logo" alt="logo" src="../assets/logo.png">
    </div>
    <div class="code_inner">TW-03401-BLI-2022-Aug</div>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue';

// export default {
//   name: 'HomeView',
//   components: {
//     HelloWorld,
//   },
// };
</script>

<style scoped lang="sass">
  .home
    position: relative
    max-width: 1200px
    margin: 0 auto
    .btnBox1
      position: absolute
      right: 38%
      top: 64%
      width: 46%
      .btn-move
        animation: move 5s infinite
    .btnBox2
      position: absolute
      right: 2%
      top: 28%
      width: 30%
      .btn-move
        animation: move 5s infinite
      .move-delay
        animation-delay: .3s
      @keyframes move
        0%
          transform: scale(1)
        12.5%
          transform: scale(1.1)
        25%
          transform: scale(1)
        100%
          transform: scale(1)
    .logoBox
      width: 100%
      position: absolute
      left: 50%
      bottom: 0
      transform: translateX(-50%)
      background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.76689) 20.66%, #FFFFFF 51.39%, rgba(255, 255, 255, 0.58214) 83.68%, rgba(255, 255, 255, 0) 100%)
      @media screen and (max-width: 1200px)
        bottom: -5%
      @media screen and (max-width: 540px)
        bottom: -10%
      .logo
        margin: 0 auto
  .code_inner
    position: fixed
    left: 0
    bottom: 0
    padding: 10px
    font-size: 12px
    font-family: 'Avenir'
    font-weight: 500
    color: #fff
    text-shadow:2px 3px 5px #4d4d4d
</style>
